import { render, staticRenderFns } from "./TableUno.vue?vue&type=template&id=6c8af942&scoped=true&"
import script from "./TableUno.vue?vue&type=script&lang=js&"
export * from "./TableUno.vue?vue&type=script&lang=js&"
import style0 from "./TableUno.vue?vue&type=style&index=0&id=6c8af942&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c8af942",
  null
  
)

export default component.exports